import React, { Component } from "react";

import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Toast,
  FormLayout,
  TextField,
  Banner,
  BlockStack,
  PageActions,
  Text,
  InlineStack,
  Box
  //  Heading, Stack, Select,Collapsible,
} from "@shopify/polaris";
import utils from "../../../../utils/utils";
// import Switch from "react-switch";
import NavTabs from "../components/NavTabs";
import { reqGetInfoSetting, reqPostUpdateUserSettings } from "../../../../api";
import "./index.css";

import intl from "../../../../i18n/intl";
import SettingPrompt from "../../../../components/SettingPrompt";
import { store } from "../../../../store";
import { changeBannerData } from "../../../../slice";
import SwitchButton from "../../OrderFulfillment/components/SwitchButton";
// 存初始数据
var DashboardData;
// 修改后的字段
const DashboardSet = new Set();
class NotificationClass extends Component {
  state = {
    // NotificationSwitch: true,

    // Situation_Product_Select: '2',
    // Situation_Variant_Select: '2',
    // Situation_Cost_Select: '3',
    // Situation_Inventory_Select: '2',

    // Notify_Product_NoAvaliable: true,
    // Notify_Variant_NoAvaliable: true,
    // Notify_Cost_Changes: true,
    // Notify_Inventory_Changes: true,

    // Variants_Inventory: 100,

    // UserEmail: '',
    // notifyReportTime: [],  // 通知report时间设置
    // timeZone: '',

    Notify_Customers: true,
    Tracking_Url: "",
    Customer_Tracking_Url: "",

    //弹窗
    showToast: false, //弹窗显示
    showToastText: "", //弹窗文字
    showToastIserror: false, //弹窗是否错误

    loadingPage: true,
    saveDataLoading: false,
    disabledSaveData: true,
    modalShow: false,
    nextUrl: "",
    is_virtual_tracking_number: true, // 是否生成订单虚拟物流单号
    synchronize: 0, //选择1
    only_synchronize: 0, //选择2
    switchValue: false, //Switch切换
  };

  //进入页面调用接口
  componentDidMount() {
   
    this.getUserSettingsData();
  }
  
   //提示弹窗
  toggleToast = (showToastText, showToastIserror = false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror,
    }));
  };

  getUserSettingsData = async () => {
    const params = { type: "notification" };
    const response = await reqGetInfoSetting(params);
    let person = store.getState().languageReducer.subScriptData
    if (response.code === "200") {
      var result = response.data;
      DashboardData = {
        Customer_Tracking_Url:
        result.custom_tracking_url !== ""
          ? result.custom_tracking_url
          : result.tracking_url,
        switchValue: result.notify_customers > 0 ? true : false,
      };
      this.setState({
        Notify_Customers: result.notify_customers > 0 ? true : false,
        Tracking_Url: result.tracking_url,
        Customer_Tracking_Url:
          result.custom_tracking_url !== ""
            ? result.custom_tracking_url
            : result.tracking_url,
        UserDomain: person.domain,
        is_virtual_tracking_number:
          result.virtual_tracking_number === 1 ? true : false,
        synchronize: result.notification_switch,
        only_synchronize: result.notification_switch,
        switchValue: result.notify_customers > 0 ? true : false,
        loadingPage: false,
        default_notify:result.notify_customers > 0 ? true : false,
        default_url: result.custom_tracking_url,
        // disabledSaveData: false
      });
    } else {
      this.toggleToast(response.msg);
    }
  };

  onChangeNotification = (type, value) => {
    if (type === "synchronize" && value === 1) {
      this.setState({
        Tracking_Url: this.state.Tracking_Url,
      });
    }
    if (type === "synchronize" && value === 2) {
      this.setState({
        Customer_Tracking_Url: this.state.Customer_Tracking_Url,
      });
    }
    this.setState({
      disabledSaveData: false,
    });
    if (type === "synchronize" && value === this.state.synchronize) {
      this.setState({
        [type]: 0,
      });
    } else if (type === "synchronize") {
      this.setState({
        [type]: value,
      });
    }
    if (type === "only_synchronize" && value === this.state.only_synchronize) {
      this.setState({
        [type]: 0,
      });
    } else if (type === "only_synchronize") {
      this.setState({
        [type]: value,
      });
    }
  };
  onChangeSwitch = (value) => {
    // if (!value) {
    //   this.setState({
    //     only_synchronize:0
    //   })
    // }
    this.setState({
      switchValue: value,
    },()=>{
      const InitialData = DashboardData['switchValue']
      const ChangeData = this.state['switchValue']
      this.checkDashboardData(InitialData, ChangeData, 'switchValue')
    });
  };
   // 检查修改过字段的数量
   checkDashboardData = async (InitialData, ChangeData, DashbardName) => {
    if (InitialData == ChangeData) { // eslint-disable-line
      DashboardSet.delete(DashbardName)
    } else {
      DashboardSet.add(DashbardName)
    }
    // 集合不会出现重复字段,如果为空说明没有任何修改
    if (DashboardSet.size) {
      this.setState({ disabledSaveData: false })
      this.props.changeSettingBtnState(true)
      window.saveSettings = {saveData:this.saveData};
      window.cancelSetting = {cancelData:this.cancelData};
    } else {
      this.setState({ disabledSaveData: true })
      this.props.changeSettingBtnState(false)
    }
  }
  // save setting
  saveData = async () => {
    this.setState({
      saveDataLoading: true,
    });
    let params = {
      type: "notification",

      // NotificationSwitch: this.state.NotificationSwitch ? 1 : 0,

      // Situation_Product_Select: this.state.Situation_Product_Select,
      // Situation_Variant_Select: this.state.Situation_Variant_Select,
      // Situation_Cost_Select: this.state.Situation_Cost_Select,
      // Situation_Inventory_Select: this.state.Situation_Inventory_Select,

      // Notify_Product_NoAvaliable: this.state.Notify_Product_NoAvaliable ? 1 : 0,
      // Notify_Variant_NoAvaliable: this.state.Notify_Variant_NoAvaliable ? 1 : 0,
      // Notify_Cost_Changes: this.state.Notify_Cost_Changes ? 1 : 0,
      // Notify_Inventory_Changes: this.state.Notify_Inventory_Changes ? 1 : 0,
      // Variants_Inventory: this.state.Variants_Inventory,

      // UserEmail: this.state.UserEmail,
      // notifyReportTime: JSON.stringify(this.state.notifyReportTime),

      Notify_Customers: this.state.switchValue ? 1 : 0,

      // is_virtual_tracking_number: 0,
      Notification_Switch: 2,
      Tracking_Url: this.state.Customer_Tracking_Url,
    };
    const responseData = await reqPostUpdateUserSettings(params);
    if (responseData.code === "200") {
      this.setState({
        disabledSaveData: true,
        saveDataLoading: false,
        default_notify: this.state.switchValue,
        default_url: this.state.Customer_Tracking_Url,
      });
      DashboardData = {
        Customer_Tracking_Url:this.state.Customer_Tracking_Url,
        switchValue: this.state.switchValue,
      };
      this.props.changeSettingBtnState(false)
      DashboardSet.clear()
      this.toggleToast("Saved successfully", false);
    } else {
      this.props.changeSettingBtnState(false)
      store.dispatch(
        changeBannerData({
          bannerData: {
            show: true,
            desc: responseData.msg,
          },
        })
      );
      // this.toggleToast(responseData.msg, true);
    }
  };

  cancelData = () => {
    this.setState({
      switchValue: this.state.default_notify,
      Customer_Tracking_Url: this.state.default_url,
      disabledSaveData: true,
    });
    this.props.changeSettingBtnState(false)
    DashboardSet.clear()
  };
  // checkbox change
  handleCheckboxChange = (value, id) => {
    this.setState({
      [id]: value,
    });
  };

  // input change
  handleInputChange = (value, id) => {
    this.setState({
      Customer_Tracking_Url: value,
    },()=>{
      const InitialData = DashboardData['Customer_Tracking_Url']
      const ChangeData = this.state['Customer_Tracking_Url']
      this.checkDashboardData(InitialData, ChangeData, 'Customer_Tracking_Url')
    });
  };
  handleUrlChange = () => {
    if (this.state.nextUrl !== "") {
      this.saveData();
      setTimeout(() => {
        //  utils.routeListen(this.state.nextUrl)
        window.history.replaceState({}, "", this.state.nextUrl);
      }, 200);
    }
  };
  handleUrlClose = () => {
    if (this.state.nextUrl !== "") {
      utils.routeJump(this, this.state.nextUrl);
    }
  };
  handleClose = () => {
    this.setState({
      modalShow: false,
    });
  };

  render() {
    const toastMarkup = this.state.showToast ? (
      <Toast
        content={this.state.showToastText}
        onDismiss={() => this.toggleToast("")}
        error={this.state.showToastIserror}
      />
    ) : null;

    const {
      // NotificationSwitch, Situation_Product_Select, Situation_Variant_Select, Situation_Cost_Select, Situation_Inventory_Select,
      // Notify_Product_NoAvaliable, Notify_Variant_NoAvaliable, Notify_Cost_Changes, Notify_Inventory_Changes, Variants_Inventory, UserEmail, notifyReportTime, timeZone,
      // Tracking_Url,
      Customer_Tracking_Url,
      saveDataLoading,
      disabledSaveData,
      switchValue,
      // synchronize,
    } = this.state;
    const ShopifyAdminUrl =
      "https://" +
      this.state.UserDomain +
      "/admin/email_templates/shipping_confirmation/edit";

    const initSkeletonPage = (
      <div>
        <Layout>
          <Layout.Section>
            <Card>
              <BlockStack gap={400}>
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
                <SkeletonBodyText lines={3} />
              </BlockStack>
            </Card>
          </Layout.Section>
        </Layout>
      </div>
    );

    const pageContent = this.state.loadingPage ? (
      initSkeletonPage
    ) : (
      <div>
        <BlockStack gap={400}>
        <Box className='h1_m'>
          
        <Text variant="headingLg" as="h5">
        Notification
        </Text>
        </Box>
        <Card>
           <Text variant="headingSm" as="h6">
           {intl.get("Notification of Order Tracking")}
            </Text>
          <FormLayout>

            <section>
              <BlockStack gap={200}>
              <div>
                  <InlineStack gap={100} blockAlign="center">
                  {intl.get(
                    "1. Email notification to customers when order is fulfilled or tracking number is generated."
                  )}
                    <SwitchButton open={switchValue} handleSwitch={()=>{this.onChangeSwitch(!switchValue)}}/>
                  </InlineStack>
              </div>
              <div
                className="notify_settings_step_section_email"
              >
                {intl.get(
                  "Change the Shopify's email notification template in"
                )}{" "}
                <a
                  style={{ color: "#4584FE", display: "inline-flex" }}
                  href={ShopifyAdminUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shopify admin{" "}
                  <img width={20} src="/share_icon.png" alt="dsmshipman"></img>{" "}
                </a>
                .
              </div>
              <div >
                <div>
                  <TextField
                    id="Tracking_Url"
                    label={intl.get("2. Shipping tracking URL")}
                    value={Customer_Tracking_Url}
                    onChange={this.handleInputChange}
                    // disabled={synchronize === 2 ? false : true}
                  />
                </div>
              </div>
              {/* </div> */}

              <div style={{ margin: "10px 0 0 0" }}>
                <Banner
                  title=""
                  tone="info"
                  // onDismiss={() => {}}
                >
                  <p>
                    {intl.get(
                      "In the absence of a set shipping tracking URL, a default"
                    )}{" "}
                    <a
                      style={{ color: "#4584FE" }}
                      href={"https://www.trackingmore.com/track"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TrackingMore
                    </a>{" "}
                    {intl.get(
                      "shipping tracking URL will be assigned. Additionally, you can customize your tracking page using"
                    )}{" "}
                    <a
                      style={{ color: "#4584FE" }}
                      href={"https://parcelpanel.com?ref=tQmHsdZJ"}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Parcel Panel
                    </a>
                    ,{" "}
                    {intl.get(
                      "which will automatically sync your configured shipping tracking URL."
                    )}
                  </p>
                </Banner>
              </div>
              </BlockStack>
            </section>
          </FormLayout>
        </Card>
        </BlockStack>
      </div>
    );
    const shopify = window.shopify;

    return (
      <div id="settings_class">
        <Page
          title={shopify ? "" : intl.get("Settings")}
          separator
        >
          <Layout>
            <Layout.Section variant="oneThird">
              <NavTabs
                selected="Notification"
                saveData={this.saveData}
                loading={saveDataLoading}
                disabled={disabledSaveData}
              />
            </Layout.Section>
            <Layout.Section>{pageContent}</Layout.Section>
          </Layout>

          {toastMarkup}
          {!shopify && <PageActions 
                    primaryAction={
                      {
                        content: intl.get("Save"),
                        onAction: this.saveData,
                        loading: saveDataLoading,
                        disabled: disabledSaveData
                      }
                    }
                    >
                      </PageActions>}
        </Page>
        {/* 未保存拦截弹窗 */}
        {!shopify && (
          <SettingPrompt
            disabledSaveData={disabledSaveData}
            url="/admin/settings/notification"
            saveData={this.saveData}
          />
        )}
      </div>
    );
  }
}

export default NotificationClass;
